module.exports = __webpack_public_path__ + "static/Metropolis-ExtraBold-a8b7f9e53314ad3712c412183e8b46c9.woff";